import { ref, readonly } from 'vue'

/**
 * Replaces the old EventBus 'show-loading' channel (App.vue listener + loadPageData emitter).
 * Single shared state, same semantics: boolean on/off drives the top progress bar in App.vue.
 */
const loading = ref(false)

export function useLoading() {
    return {
        loading: readonly(loading),
        showLoading: (value: boolean) => { loading.value = value }
    }
}
